import styled from 'styled-components';

import { Button } from '@nw/omega-design-system';
import { mobile } from '@nw/shared/utils';

export const ChangeProgramInfoText = styled('span')`
  font-family: 'Inter';
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.75;
  letter-spacing: 0.2px;
  color: #7b8794;
  margin-bottom: 36px;
  text-align: left;
  white-space: pre-line;
`;

export const ChangeProgramHeaderContainer = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  @media (max-width: 770px) {
    justify-content: space-between;
  }
`;

export const ChangeProgramTitle = styled('span')`
  font-family: 'Inter';
  font-size: 24px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: 0.2px;
  color: #183b56;
  margin-bottom: 24px;
`;

export const ProceedButton = styled(Button)`
  font-family: 'Inter';
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.75;
  letter-spacing: 0.2px;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 16px;
`;

export const ChangeProgramCheckboxMessage = styled('span')`
  font-family: 'Inter';
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.75;
  letter-spacing: 0.2px;
`;

export const ErrorMessage = styled.div`
  font-family: Inter;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  text-align: left;
  margin-bottom: 8px;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  color: rgba(220, 38, 38);
  text-align: center;
`;
